import { axiosWC } from "./axios";
import { toast } from "react-toastify";

// gives current date independent of the system
export const getCurrentDate = async () => {
  const response = await axiosWC.get(
    `${process.env.REACT_APP_DJANGO_API_URL.replace("v1", "resource")}`
  );

  return new Date(response?.headers?.["x-date"]);
};

// copy the content of particular html element given its id
export const copyToClipboard = ({ data, elementId }) => {
  try {
    if (typeof data !== "undefined") navigator.clipboard.writeText(data);
    else {
      const range = document.createRange();
      range.selectNode(document.getElementById(elementId));
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      navigator.clipboard.writeText(window.getSelection().toString());
      window.getSelection().removeAllRanges();
    }

    return true;
  } catch {
    return false;
  }
};

export const notify = (msg, autoClose = 5000) =>
  toast.info(
    <div
      dangerouslySetInnerHTML={{
        __html: msg,
      }}
    />,
    {
      position: "top-right",
      autoClose,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
    }
  );

export const openLoginModal = () =>
  document.querySelector("button.signinButton.gfg_loginModalBtn")?.click();
